import router from "./router";
/* eslint-disable */
import { getAccessToken, getMe } from "./utils/accessToken";

const whiteList = ["/login"];
const hasToken = getAccessToken();

router.beforeEach(async(to, from, next) => {
    let current = to.path.split('/')
    let isExist = false

    if (hasToken) {
        try {
            let meData = getMe();
            // Safely parse cookie to prevent XSS from compromised cookies
            let cookie = typeof meData === 'string' ? JSON.parse(meData) : meData;
            
            // Validate that cookie has expected structure
            if (!cookie || typeof cookie !== 'object' || !Array.isArray(cookie.scopes)) {
                // Invalid cookie structure - redirect to login
                next(`/login?redirect=${to.path}`);
                return;
            }
            
            if (cookie.scopes.find(e => e == current[1]) || to.path == '/dashboard') {
                isExist === true
            }
            if (to.path === "/login") {
                next({ path: "/" });
            } else if (cookie.scopes.find(e => e == current[1]) || to.path == '/dashboard') {
                next()
            } else {
                next(`/dashboard?forbidden=true`);
            }
        } catch (error) {
            // Cookie parse error - possibly corrupted or XSS attempt
            console.error("Invalid user data in cookie");
            next(`/login?redirect=${to.path}`);
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next(`/login?redirect=${to.path}`);
        }
    }
});